import { useEffect, useState } from 'react'
import { brand, navItems } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Header.module.css'

export function Header() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Bloquea el scroll del body cuando el menú móvil está abierto.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <div className={`container ${styles.inner}`}>
        <a href="#inicio" className={styles.logo} onClick={() => setOpen(false)}>
          <span className={styles.logoMark}>EH</span>
          <span className={styles.logoName}>{brand.name}</span>
        </a>

        <nav className={styles.nav} aria-label="Navegación principal">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className={styles.link}>
              {item.label}
            </a>
          ))}
        </nav>

        <a href="#contacto" className={`btn btn--primary ${styles.cta}`}>
          Trabajemos juntos
        </a>

        <button
          className={styles.burger}
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <Icon name={open ? 'close' : 'menu'} size={24} />
        </button>
      </div>

      {/* Menú móvil */}
      <div className={`${styles.mobile} ${open ? styles.mobileOpen : ''}`}>
        <nav className={styles.mobileNav} aria-label="Navegación móvil">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className={styles.mobileLink} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
          <a href="#contacto" className={`btn btn--primary btn--lg ${styles.mobileCta}`} onClick={() => setOpen(false)}>
            Trabajemos juntos
          </a>
        </nav>
      </div>
    </header>
  )
}
